/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DashboardDefinition from './DashboardDefinition';
import Options from './Options';

/**
* The GetDashboardResponse model module.
* @module model/GetDashboardResponse
* @version 2020-12-7
*/
export default class GetDashboardResponse {
    /**
    * Constructs a new <code>GetDashboardResponse</code>.
    * @alias module:model/GetDashboardResponse
    * @class
    * @param dashboards {Array.<module:model/DashboardDefinition>} 
    * @param result {module:model/GetDashboardResponse.ResultEnum} 
    */

    constructor(dashboards, result) {
        
        
        this['dashboards'] = dashboards;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>GetDashboardResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GetDashboardResponse} obj Optional instance to populate.
    * @return {module:model/GetDashboardResponse} The populated <code>GetDashboardResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetDashboardResponse();
                        
            
            if (data.hasOwnProperty('dashboards')) {
                obj['dashboards'] = ApiClient.convertToType(data['dashboards'], [DashboardDefinition]);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * @member {Array.<module:model/DashboardDefinition>} dashboards
    */
    'dashboards' = undefined;
    /**
    * @member {module:model/GetDashboardResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
